/**
 * @memberof data-references
 * @property {number[]} characteristic_types
 * @property {string[]} dimensions
 * @property {string[]} categories
 * @property {number} ndim
 * @property {string} statistical_type
 * @property {string} time_group
 * @property {string} time_element
 * @property {string} time_context
 * @property {string} start
 * @property {string} end
 * @property {string} sort
 * @property {number} offset
 * @property {number} limit
 */
class BaseQueryParameters {
    constructor(props) {
        Object.assign(this, props);
    }
}
export default BaseQueryParameters;
